import { Dropdown } from "primereact/dropdown";
import { Fieldset } from "primereact/fieldset";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Tree } from "primereact/tree";
import { useRef, useState, useEffect } from "react";
import TableSeplag from "../../../components/TableSeplag";
import CardSeplag from "../../../components/CardSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { SplitButton } from "primereact/splitbutton";
import {
  adicionarPermissao,
  adicionarPermissaoPrograma,
  adicionarPermissaoUoPrograma,
  buscarArvoreRag,
  buscarArvoreRagOrgaos,
  buscarArvoreRagUos,
  getArvoreRag,
  listarPermissaoPtaMonitora,
  removerPermissaoUsuario,
  removerPermissaoUsuarioUO,
} from "../../../service/Rag/Permissoes";
import FilterUser from "./FilterUser";
import { Message } from "primereact/message";
import "./style.css";

const RagPermissoes = () => {
  const [data, setData] = useState({
    exercicios: [],
    orgaos: [],
    uos: [],
    arvoreRag: [],
    usuarioBusca: [],
    messagemUsuario: null,
    usuarios: null,
    permissaoRag: null,
  });
  const [permissaoSelected, setPermissaoSelected] = useState(null);
  const itemsBotao = [
    {
      label: "Por item",
      icon: "pi pi-eye",
      command: (e) => {
        adicionarPermissaoVisualizar({ type: "UO" });
      },
    },
    {
      label: "Por Programa",
      icon: "pi pi-eye",
      command: () => {
        adicionarPermissaoVisualizar({ type: "Programa" });
      },
    },
    {
      label: "Por UO",
      icon: "pi pi-eye",
      command: () => {
        adicionarPermissaoVisualizar({ type: "UO" });
      },
    },
  ];
  const itemsBotaoRemover = [
    {
      label: "Por item",
      icon: "pi pi-eye",
      command: () => {
        removerPermissaoVisualizar({ type: "item" });
      },
    },
    {
      label: "Por UO",
      icon: "pi pi-eye",
      command: () => {
        removerPermissaoVisualizar({ type: "UO" });
      },
    },
  ];
  const [userSelected, setUserSelected] = useState(null);
  const [visibleFilter, setVisibleFilter] = useState(false);
  const [filter, setFilter] = useState({ exercicio: null, orgao: null, uo: null });
  const toast = useRef(null);
  const camposTabela = [
    { titulo: "Nome", nome: "contaAcesso.pessoa.nomePessoa" },
    {
      titulo: "Permissão",
      nome: "flagTipoPermissao",
      body: (rowData) => {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            {rowData.flagTipoPermissao === "V" ? "Visualização" : "Edição"}
          </span>
        );
      },
    },
  ];

  const changeExercicio = (e) => {
    setFilter({
      exercicio: e.value,
      orgao: null,
      uo: null,
    });
    if (e.value !== undefined) {
      buscarArvoreRagOrgaos(e.value.idenExercicio).then((res) => {
        setData((prevState) => ({
          ...prevState,
          orgaos: res,
          uos: null,
          arvoreRag: null,
          usuarioBusca: [],
        }));
      });
    }
  };

  const changeOrgao = (e) => {
    if (e.value === undefined) {
      setFilter((prevState) => ({
        exercicio: prevState.exercicio,
        orgao: null,
        uo: null,
        usuarioBusca: [],
      }));
    }

    if (e.value !== undefined) {
      setFilter((prevState) => ({
        ...prevState,
        orgao: e.value,
      }));
      buscarArvoreRagUos(e.value.idenOrgao).then((res) => {
        setData((prevState) => ({
          ...prevState,
          uos: res,
          arvoreRag: null,
        }));
      });
    }
  };

  const changeUo = (e) => {
    if (e.value === undefined) {
      setFilter((prevState) => ({
        ...prevState,
        uo: null,
      }));
      setData((prevState) => ({
        ...prevState,
        arvoreRag: null,
      }));
    }
    if (e.value !== undefined) {
      setFilter((prevState) => ({
        ...prevState,
        uo: e.value,
      }));

      getArvoreRag(filter.orgao.idenOrgao, e.value.idenUo).then((res) => {
        return setData((prevState) => ({
          ...prevState,
          arvoreRag: res?.data.content.map((item) => {
            let totalAcao = item.children.length;
            let totalObjetivos = item.programa.objetivos.length;
            let totalIndicadores = item.programa.objetivos.reduce((acc, current) => {
              return acc + current.indicadores.length;
            }, 0);
            return { ...item, totalAcao, totalIndicadores, totalObjetivos };
          }),
        }));
      });
    }
  };

  const nodeTemplate = (node, options) => {
    let label;
    label = "PROGRAMA " + node.programa.codgPrograma + " " + node.descricaoItem;
    if (node.tipoItem === "AÇÃO") {
      label = "AÇÃO: " + node.codFiplanItem + " " + node.descricaoItem;
    }

    return (
      <span style={{ cursor: "pointer" }} className={options.className} onClick={() => onNodeSelect(node)}>
        {label}
      </span>
    );
  };

  const onNodeSelect = (node) => {
    listarPermissaoPtaMonitora(node.idenItem).then((res) => {
      setData((prevState) => ({
        ...prevState,
        usuarios: res,
        messagemUsuario: res?.length === 0 ? true : false,
        permissaoRag: node,
      }));
    });
  };

  const handlerUser = () => {
    setVisibleFilter(true);
  };

  const adicionarPermissaoVisualizar = ({ type }) => {
    if (userSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nem um Usuario para autorizar a permissao UO",
        life: 5000,
      });
    }

    if (data.permissaoRag === null && type === "all permission") {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nem um Programa/Ação para autorizar a permissao",
        life: 5000,
      });
    }

    if (data.permissaoRag === null && type === "Programa") {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nenhum Programa para autorizar a permissao",
        life: 5000,
      });
    }
    if (type === "Programa") {
      let postBodyPrograma = {
        contaAcesso: {
          id: userSelected.id,
        },
        uo: {
          idenUo: filter.uo.idenUo,
        },
        programa: {
          idenPrograma: data.permissaoRag.programa.idenPrograma,
        },
      };
      return adicionarPermissaoPrograma(postBodyPrograma).then((_res) => {
        window.$toast.current.show({
          severity: "success",
          summary: "Concluido",
          detail: "Permissão por Programa inserida com Sucesso",
          life: 5000,
        });
        onNodeSelect(data.permissaoRag);
      });
    }
    if (type === "UO") {
      let postBodyUo = {
        contaAcesso: {
          id: userSelected.id,
        },
        uo: {
          idenUo: filter.uo.idenUo,
        },
        programa: {
          idenPrograma: null,
        },
      };
      return adicionarPermissaoUoPrograma(postBodyUo).then((_res) => {
        window.$toast.current.show({
          severity: "success",
          summary: "Concluido",
          detail: "Permissão por Programa inserida com Sucesso",
          life: 5000,
        });
        onNodeSelect(data.permissaoRag);
      });
    }
    let postBody = {
      contaAcesso: {
        id: userSelected.id,
      },
      exercicio: {
        idenExercicio: data.permissaoRag.exercicio.idenExercicio,
      },
      sistema: {
        idenSistema: 4,
      },
      idenItemRag: data.permissaoRag.idenItem,
      flagTipoPermissao: "V",
      statPermissaoPtaRag: 1,
    };
    return adicionarPermissao(postBody).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Concluido",
        detail: "Permissão inserida com Sucesso",
        life: 5000,
      });
      onNodeSelect(data.permissaoRag);
    });
  };

  const removerPermissaoVisualizar = ({ type }) => {
    if (userSelected === null) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nem um Usuario para autorizar a permissao ",
        life: 5000,
      });
    }
    if (data.permissaoRag === null && (type === "all permission" || type === "item")) {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nenhuma UO para revogar a permissao",
        life: 5000,
      });
    }

    if (filter.uo === null && type === "UO") {
      return window.$toast.current.show({
        severity: "error",
        summary: "Erro na Validação",
        detail: "Não foi selecionado nenhuma UO para autorizar a permissao",
        life: 5000,
      });
    }
    if (type === "UO") {
      let postBodyUo = {
        contaAcesso: {
          id: userSelected.contaAcesso.id,
        },
        uo: {
          idenUo: filter.uo.idenUo,
        },
        programa: {
          idenPrograma: null,
        },

        flagExclusao: "S",
      };

      return removerPermissaoUsuarioUO(postBodyUo).then((_res) => {
        window.$toast.current.show({
          severity: "success",
          summary: "Concluido",
          detail: "Permissão por UO revogada com Sucesso",
          life: 5000,
        });
        onNodeSelect(data.permissaoRag);
      });
    }

    let postBody = {
      contaAcesso: {
        id: userSelected.contaAcesso.id,
      },
      exercicio: {
        idenExercicio: data.permissaoRag.exercicio.idenExercicio,
      },
      sistema: {
        idenSistema: userSelected.sistema.idenSistema,
      },
      idenItemRag: data.permissaoRag.idenItem,
      flagTipoPermissao: userSelected.flagTipoPermissao,
      statPermissaoPtaRag: userSelected.statPermissaoPtaRag,
      flagExclusao: "S",
      flagExclusaoPai: "S",
    };
    return removerPermissaoUsuario(postBody).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Concluido",
        detail: "Usuario Removido com Sucesso",
        life: 5000,
      });
      onNodeSelect(data.permissaoRag);
    });
  };
  const selectedUser = (userRow) => {
    setUserSelected(userRow);
  };
  useEffect(() => {
    buscarArvoreRag().then((res) => {
      setData((prevState) => ({
        ...prevState,
        exercicios: res.listaExercicios,
        orgaos: res.orgaoFiplans,
        uos: res.unidadeOrcamentarias,
        arvoreRag: res?.arvorePtaMonitoras.content.map((item) => {
          let totalAcao = item.children.length;
          let totalObjetivos = item.programa.objetivos.length;
          let totalIndicadores = item.programa.objetivos.reduce((acc, current) => {
            return acc + current.indicadores.length;
          }, 0);
          return { ...item, totalAcao, totalIndicadores, totalObjetivos };
        }),
      }));
      setFilter({
        exercicio: res.listaExercicios[0],
        orgao: res.orgaoFiplans[0],
        uo: res.unidadeOrcamentarias[0],
      });
    });
  }, []);
  return (
    <CardSeplag title="Lançamento de Permissões">
      <Toast ref={toast} />
      <Fieldset>
        <form>
          <div className="p-fluid grid">
            <div className="field col-12 md:col-3 ">
              <RotuloSeplag nome={"Exercício"}>
                <Dropdown
                  placeholder="Selecione o Exercício"
                  id="exercicio"
                  name="exercicio"
                  optionLabel="ano"
                  options={data.exercicios}
                  value={filter.exercicio}
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  filter
                  showClear
                  filterBy="ano"
                  onChange={(e) => {
                    changeExercicio(e);
                  }}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-3">
              <RotuloSeplag nome="Órgão">
                <Dropdown
                  placeholder="Selecione o Órgão do Exercício"
                  id="descricaoFiplan"
                  name="descricaoFiplan"
                  optionLabel="descricaoFiplan"
                  options={data.orgaos}
                  value={filter.orgao}
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  onChange={(e) => {
                    changeOrgao(e);
                  }}
                />
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-3">
              <RotuloSeplag nome="U.O." cols="12 3">
                <Dropdown
                  placeholder="Selecione o UO do Exercício"
                  id="descricaoFiplan"
                  name="descricaoFiplan"
                  optionLabel="descricaoFiplan"
                  options={data.uos}
                  value={filter.uo}
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  onChange={(e) => {
                    changeUo(e);
                  }}
                />
              </RotuloSeplag>
            </div>
          </div>
        </form>
      </Fieldset>
      {data.arvoreRag !== null && (
        <Fieldset>
          <Tree value={data.arvoreRag} nodeTemplate={nodeTemplate} className="p-treetable" />
        </Fieldset>
      )}
      <Message
        style={{ width: "100%", textAlign: "left" }}
        severity="warn"
        text="Selecione um item para atribuir/remover uma permissão"
      />
      <Fieldset>
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid">
            <div className="field col-12 md:col-3 ">
              <Button label="Buscar" className="p-button-success" icon="pi pi-search" onClick={handlerUser} />
            </div>
            <div className="field col-12 md:col-3 ">
              <InputText
                value={userSelected === null ? "" : userSelected?.pessoa?.nomePessoa}
                placeholder="Selecione um usuario"
                disabled
              />
            </div>
            <div className="field col-12 md:col-3 ">
              <SplitButton
                label="Permissão de Visualizar"
                icon="pi pi-eye"
                model={itemsBotao}
                onClick={() => {
                  adicionarPermissaoVisualizar({ type: "all permission" });
                }}
              />
            </div>
            <div className="field col-12 md:col-3 ">
              <SplitButton
                label="Revogar Permissão"
                className="p-button-danger"
                icon="pi pi-trash"
                model={itemsBotaoRemover}
                onClick={() => {
                  removerPermissaoVisualizar({ type: "remove permission" });
                }}
              />
            </div>
          </div>
        </div>
      </Fieldset>
      {data.usuarios !== null && (
        <>
          <Message
            style={{ width: "100%", textAlign: "left", fontWeight: "bold" }}
            severity="success"
            text={data.permissaoRag.descricaoItem}
          />
          <TableSeplag
            camposTabela={camposTabela}
            dados={data.usuarios}
            selectionMode="single"
            onSelectionChange={selectedUser}
            dataKey="contaAcesso.id"
          />
        </>
      )}
      {visibleFilter && (
        <FilterUser
          visibleFilter={visibleFilter}
          setVisibleFilter={setVisibleFilter}
          setUserSelected={setUserSelected}
        />
      )}
    </CardSeplag>
  );
};
export default RagPermissoes;
